/**
 * Module dependencies.
 */

import { AxiosInstance } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * Forgot password.
 */

function forgotPassword(client: AxiosInstance, email: string): Promise<void> {
  return client.post(resolveAppUrl('forgotPassword'), { email }).then(({ data }) => data);
}

/**
 * `Options` type.
 */

type Options = UseMutationOptions<void, unknown, string, unknown>;

/**
 * Export `useForgotPassword`.
 */

export function useForgotPassword(options?: Options) {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (email: string) => {
      return await forgotPassword(client, email);
    },
    ...options
  });
}
